// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BKmX","badges":"styles_badges__17XYw"};